import { AssetModelData } from "../../files/asset.interface";
import { FileObject } from "../../files/file-object";

export const resolveAssetPaths = (file: FileObject, asset: AssetModelData) => {
  let convertedFilePath: string | undefined;
  if (file.operation) {
    // Take the result of completed file operations and assign them to
    // the convertedFilePath property
    const operation = asset?.jobs?.[file.operation?.name];

    if (operation?.status === "done" && operation?.result) {
      if ("hd" in operation.result) {
        // Take the HD variant for video transcode operations
        convertedFilePath = operation.result.hd;
      } else if ("url" in operation.result) {
        // Take the url for remove background & trackable operations
        convertedFilePath = operation.result.url;
      }
    }
  }
  // Assets from the AI image generator carry origin "generated"; mirror that
  // onto the file object so renderers can show the "AI" badge without access
  // to the asset list (AI Act art. 50).
  const metadata =
    asset?.origin === "generated"
      ? { ...file.metadata, aiGenerated: true }
      : file.metadata;

  return {
    path: asset?.src,
    convertedFilePath,
    metadata,
  };
};
